import 'isomorphic-fetch';
import { isObject } from './misc';
import { message, notification, Modal } from 'antd';
import cache from '../cache';
import localStorage from '../localStorage';
import bignumJSON from '../bignumJSON/json';
import { headersMethod } from '../requestHeaderMethod';

import FormData from 'form-data';
import LZString from 'lz-string';
import { intercept, pathReplace } from './intercept';
const decompressUrlQuery = str => LZString.decompressFromEncodedURIComponent(str);

const noop = () => {
	//  do nothing
};

const mockData = function (data, time) {
	return new Promise((resolve, reject) => {
		setTimeout(() => {
			resolve(data);
		}, time || 1000);
	});
};
//是否传空参数值,需要时在 callApi 里加上这个参数即可
let isNeedEmpty = false;

const noPrivilegeKey = 'noPrivilegeKey';

function prepend(prefix, name, separator) {
	if (prefix) {
		if (separator) { return prefix + '.' + name; }

		return prefix + name;
	}
	return name;
}

function flatten(prefix, obj, map) {
	if (!isNeedEmpty && !(obj || obj === 0)) {
		return;
	}
	if (obj !== undefined) {
		if (Array.isArray(obj)) {
			for (let i = 0; i < obj.length; i++) {
				const item = obj[i];
				flatten(prepend(prefix, '[' + i + ']', false), item, map);
			}
		} else if (isObject(obj)) {
			if (obj.__type__ === 'map') {
				for (const key in obj) {
					if (key !== '__type__') { flatten(prepend(prefix, '[' + key + ']', false), obj[key], map); }
				}
			} else if (obj instanceof File) {
				// deal with JS based file load
				map[prefix] = obj;
			} else {
				for (const key in obj) {
					flatten(prepend(prefix, key, true), obj[key], map);
				}
			}
		} else {
			map[prefix] = obj;
		}
	}
}

export function toFlattenMap(obj) {
	const map = {};
	isNeedEmpty = false;
	if (obj.isNeedEmpty) {
		delete obj.isNeedEmpty;
		isNeedEmpty = true;
	}
	flatten(null, obj, map);
	return map;
}

export function composeFetch(service, endpoint, data, headers, requestJson) {
	// 在wepark环境下，需要统一加上 /zuolin/private 前缀
	if (window.envType === 'wepark') service = '/zuolin/private' + service;
	let fullUrl = service ? service + endpoint : endpoint;

	const method = !!data && !!data.method ? data.method : 'POST';
	if (requestJson) {
		return {
			fullUrl,
			fetchData: {
				headers,
				credentials: 'same-origin',
				method,
				body: JSON.stringify(data.commandObject || {})
			}
		};
	}
	if (method === 'POST' || method === 'PUT') {
		const params = new FormData();
		if (!!data && !!data.commandObject) {
			const flattenMap = toFlattenMap(data.commandObject);
			for (const key in flattenMap) {
				params.append(key, flattenMap[key]);
			}
		}
		return ({
			fullUrl,
			fetchData: {
				headers,
				credentials: 'same-origin',
				method,
				body: params
			}
		});
	}
	const params = [];
	if (!!data && !!data.commandObject) {
		const flattenMap = toFlattenMap(data.commandObject);

		let i = 0;
		for (const key in flattenMap) {
			if (i++ === 0) { params.push('?'); } else { params.push('&'); }

			params.push(encodeURIComponent(key) + '=' + encodeURIComponent(flattenMap[key]));
		}

		if (params.length > 0) { fullUrl = fullUrl + params.join(''); }
	}

	return ({
		fullUrl,
		fetchData: {
			credentials: 'same-origin',
			method
		}
	});
}

/**
 * 网络请求
 * @typedef {{service?: string,api: string,method?: string,data?: any,success?: Function,error?: Function,complete?: Function,noPrivilege?: Function,defaultError?: boolean,ignoreNamespaceId?: boolean,ignoreModulePath?: boolean,responseType?:string, }} ReqConfig
 * @param {ReqConfig} service 请求参数
 * @returns {Promise<any>}
 */
export function callApi (service) {
	if ((!service.api || service.mockResponse) && process.env.NODE_ENV === 'development') {
		console.log(service.data, service.api)
		return mockData(service.mockResponse, 0).then((res) => (service?.success ? service.success(res) : res))
	}
	let { api, data: commandObject = {}, method, success = noop, error, noPrivilege, defaultError = true, ignoreNamespaceId = false, complete = noop, ignoreModulePath = false, signal, responseType = 'text', requestJson = false } = service;
	// let { service: prefix = '/evh', api, data: commandObject = {}, method, success = noop, error, noPrivilege, defaultError = true, ignoreNamespaceId = false, complete = noop, ignoreModulePath = false, signal, responseType = 'text', requestJson = false } = service;
	const prefix = intercept(service);
	api = pathReplace(api);
	// 自动加上 namespaceId 参数
	const namespaceId = window.$$context && window.$$context.namespaceId;
	if (!ignoreNamespaceId) commandObject = Object.assign({ namespaceId }, commandObject);
	// 自动加上 _modulePath 参数
	const _modulePath = window.$$context && window.$$context._modulePath;
	if (!ignoreModulePath) commandObject = Object.assign({ _modulePath }, commandObject);
	// api是资管自动加上 moduleId 参数
	const moduleId = window.$$context && window.$$context.moduleId;
	const reg = /^\/asset\//;
	if (reg.test(api)) commandObject = Object.assign({ moduleId }, commandObject);
	// 请求header中增加字段
	let headers = { ...(service?.headers) };
	const isOA = window.env !== 'EhZuolinAdmins';
	if (isOA) {
		headers = {
			...(headers || {}),
			'X-Context': headersMethod.genXContext(),
		};
	}
	if (requestJson) {
		headers['content-type'] = 'application/json';
	}
	const fetchInfo = composeFetch(prefix, api, { commandObject, method }, headers, requestJson);
	return new Promise((resolve, reject) => {
		const fetchPromise = fetch(fetchInfo.fullUrl, { ...fetchInfo.fetchData, signal })
			.then((response) => {
				if (responseType === 'blob') {
					return response.blob();
				}
				return response.text().then(text => text);
			})
			.then((response) => {
				if (responseType === 'blob') {
					resolve(response);
					success(response);
					return;
				}
				let data = bignumJSON.parse(response);

				// 8.3.3 版本以前的报表接口处理逻辑
				if (data.q) {
					data = JSON.parse(decompressUrlQuery(data.q));
					data.errorCode = data.err_code;
					data.response = data.data;
				}
				// 8.3.3 版本及以后的报表接口处理逻辑
				if (prefix === '/report') {
					if (data.errorCode === 'A00000') {
						resolve(data.data);
						success(data.data);
					} else {
						reject(data);
					}
					return;
				}

				if (Number(data.errorCode) === 200) {
					resolve(data.response);
					success(data.response);
				} else if (Number(data.errorCode) === 100055) {
					notification.warning({
						key: 'noPrivilege',
						message: '权限不足',
						description: '你暂无此功能权限，请联系管理员。'
					});

					if (noPrivilege) {
						noPrivilege(data);
					} else {
						reject(data);
						error && error(data);
					}
				} else if (Number(data.errorCode) === 401) {
					// 接口授权不通过时，统一跳转到登录页
					let url = window.location.origin + window.location.pathname;
					url = url.replace(/[^/]+\.html$/, 'index.html');
					url = url + '#/login';
					window.location.href = url;
				} else if (Number(data.errorCode) === 100027) {
					if (!localStorage.read('basic_info')) {
						return;
					}
					reject(data);
					notification.warning({
						message: '',
						description: '登录信息过期，请重新登录。'
					});
					localStorage.clearAll();
					cache.clear();
					document.cookie = 'token' + '=;expires=' + (new Date(0)).toGMTString();
					let url = window.location.origin + window.location.pathname;
					url = url.replace(/[^/]+\.html$/, 'index.html');
					url = url + '#/login';
					if (window.location.href === url) {
						window.location.reload();
					} else {
						window.location.href = url;
					}
				} else if (Number(data.errorCode) === 100028) {
					if (!localStorage.read('basic_info')) {
						return;
					}
					reject(data);
					notification.warning({
						message: '',
						description: '密码已修改，请重新登录'
					});
					localStorage.clearAll();
					cache.clear();
					document.cookie = 'token' + '=;expires=' + (new Date(0)).toGMTString();
					let url = window.location.origin + window.location.pathname;
					url = url.replace(/[^/]+\.html$/, 'index.html');
					url = url + '#/login';
					if (window.location.href === url) {
						window.location.reload();
					} else {
						window.location.href = url;
					}
				} else if (Number(data.errorCode) === 600016) {
					Modal.warning({
						content: data.errorDescription + '，无法使用，请联系客服',
						okText: '退出',
						onOk: () => {
							localStorage.clearAll();
							cache.clear();
							document.cookie = 'token' + '=;expires=' + (new Date(0)).toGMTString();
						}
					});
					let url = window.location.origin + window.location.pathname;
					url = url.replace(/[^/]+\.html$/, 'index.html');
					url = url + '#/login';
					window.location.href = url;
				} else if (Number(data.errorCode) === 100018) {
					message.error(data.errorDescription || '系统异常，请稍候再试', 1.5);
					localStorage.clearAll();
					cache.clear();
					document.cookie = 'token' + '=;expires=' + (new Date(0)).toGMTString();
					let url = window.location.origin + window.location.pathname;
					url = url.replace(/[^/]+\.html$/, 'index.html');
					url = url + '#/login';
					window.location.href = url;
				} else {
					reject(data);
					if (error) { error(data); } else if (defaultError) { message.error({ key: data.errorCode, content: data.errorDescription || '系统异常，请稍候再试', duration: 1.5 }); }
				}
			})
			.catch((err) => {
				console.error(err);
				// 避免promise永远处于pending状态
				reject(err);
			});
		if (!('finally' in fetchPromise)) fetchPromise.finally = Promise.prototype.finally;
		fetchPromise.finally(() => {
			if (complete) {
				complete();
			}
		});
	});
}

export function callRaw(service, endpoint, data, headers) {
	const fetchInfo = composeFetch(service, endpoint, data, headers);
	return fetch(fetchInfo.fullUrl, fetchInfo.fetchData);
}
